import { TableColumn } from 'types/types'
import { TableActionConfig } from 'components/Table/types'
import { TableActions } from 'components/Table/TableActions'

export const deviceTypeTableColumns = <T,>({
  actions,
}: {
  actions: TableActionConfig<T>[]
}): TableColumn[] => [
  { id: 'name', label: 'Name', minWidth: 170 },
  { id: 'manufacturer', label: 'Manufacturer', minWidth: 170 },
  { id: 'first_x', label: 'First X', minWidth: 100 },
  { id: 'last_x', label: 'Last X', minWidth: 100 },
  {
    id: 'actions',
    label: '',
    minWidth: 100,
    align: 'right',
    format: (_, row: T) => <TableActions actions={actions} row={row} />,
  },
]
